/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit,
  Input,
  OnChanges
} from '@angular/core';
import { debounceTime, fromEvent, map } from 'rxjs';
import { assetsConst } from 'src/app/core/const/assets.const';
@Component({
  selector: 'megastore-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements AfterViewInit, OnChanges {
  @ViewChild('search') searchRef!: ElementRef;
  assetsConst = assetsConst;
  showCrossIcon = false;

  @Output() searchOutput: EventEmitter<any> = new EventEmitter();
  @Output() focusSearch = new EventEmitter();
  @Input() search = '';

  focusFunction(): void {
    this.focusSearch.emit(true);
  }

  focusOutFunction(): void {
    this.focusSearch.emit(false);
  }

  ngOnChanges(): void {
    if (this.search === '') this.clearInputField();
  }

  ngAfterViewInit(): void {
    if (this.searchRef) {
      fromEvent(this.searchRef.nativeElement, 'keyup')
        .pipe(
          map((i: any) => i.target.value),
          debounceTime(500)
        )
        .subscribe((res: any) => {
          if (res) {
            this.showCrossIcon = true;
            this.search = res;
            this.searchOutput.emit(res);
          } else {
            this.showCrossIcon = false;
            this.search = '';
            this.searchOutput.emit(res);
          }
        });
    }
  }

  clearInputField(): void {
    if (this.searchRef) {
      this.searchRef.nativeElement.value = '';
      this.search = '';
      this.showCrossIcon = false;
      this.searchOutput.emit(null);
    }
  }

  @Input() placeholderText: any;
}
